/* unplugin-vue-components disabled */import { render } from "./Home.vue?vue&type=template&id=8dec3c0e&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=8dec3c0e&scoped=true&lang=scss"
import "./Home.vue?vue&type=style&index=1&id=8dec3c0e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dec3c0e"]])

export default __exports__